import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GuestLogin } from '@app/dto/GuestLogin';
import { environment } from '@environments/environment';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {

  constructor( private http:HttpClient) {

   }

   CreateGuestToken (data: GuestLogin) {
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    return this.http.post(environment.exiBackendUrl+"/api/CreateGuestToken",data,{headers})
   }

   CheckHosPassword( password: string) {
    return this.http.get(environment.exiBackendUrl+"/api/CheckHosPass/"+password)
   }

   CreateTabletToken( dailyPass : string, hotel3pId : string) {
     return this.http.get(environment.exiBackendUrl+"/api/CreateTabletToken/"+dailyPass+"/"+hotel3pId)
   }
}
